import {Dictionary} from "../types/Types";
import * as Cookies from "js-cookie";
import {ROUTES, STUDIO_SESSION_COOKIE_DEV, STUDIO_SESSION_COOKIE_PROD} from "./constants";
import history from "./history";

export function buildRoute(routeTemplate: string, parameters: Dictionary<string>): string {
  for (const param in parameters) {
    if (parameters.hasOwnProperty(param)) {
      routeTemplate = routeTemplate.replace(param, parameters[param])
    }
  }

  return routeTemplate;
};

export const logout = () => {

  if (Cookies.get(STUDIO_SESSION_COOKIE_PROD)) {
    Cookies.remove(STUDIO_SESSION_COOKIE_PROD, {path: '/', domain: 'vitalsource.com'});
  }

  if (Cookies.get(STUDIO_SESSION_COOKIE_DEV)) {
    Cookies.remove(STUDIO_SESSION_COOKIE_DEV, {path: '/', domain: 'vitalbook.com'});
  }

  if (history.location.pathname !== ROUTES.AUTH) {
    history.push(ROUTES.AUTH);
  }
}

export const fourOhFour = () => {
  history.push(ROUTES.FOUR_OH_FOUR);
}
